import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useAddCard } from 'components/detail/edit/EditDetail/EditDetailCards/AddCard/useAddCard';
import { S_WebButtonSmaller } from 'elements/button/WebButton';
import { ActionButton as ActionButton2 } from 'elements/minute/sidebar/sidebarComponents/atomic/ActionButton';
import { SidebarGrid } from 'elements/minute/sidebar/sidebarComponents/complex/SidebarGrid/SidebarGrid';
import { motion } from 'framer-motion';
import { ANIMATION_APPEAR } from 'libs/styles/animations';
import { EColors, EFonts, EShadows } from 'libs/styles/styling';
import { ICardView } from 'libs/types/card/cardTypes';
import { createCardBody } from 'libs/utils/card/cardUtils';
import React, { useContext } from 'react';
import { CtxDetail } from 'session/ctxDetail';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';

interface Props {
    position: number;
    className?: string;
}

export const AddCard = (props: Props): JSX.Element => {
    const ctxDetail = useContext(CtxDetail);
    const [show, setShow] = React.useState(false);
    const addCard = useAddCard();

    function add(card: ICardView) {
        ctxDetail.addCardByPosition(
            {
                type: card.cardType,
                cardId: Math.random().toString(),
                ...createCardBody(card.cardType)
            },
            props.position
        );
        ctxDetail.setUpdatingIndex(props.position);
        setShow(false);
    }

    function showCards() {
        setShow(!show);
        ctxDetail.setUpdatingIndex(-2);
    }

    return (
        <S_AddCard className={props.className}>
            <S_Mid>
                {!show && ctxDetail.updateDetailInput?.cards?.length === 0 ? (
                    <S_WebButtonSmaller
                        shadow={EShadows.LIGHT}
                        type="primary"
                        text={Localization.ADD_FIRST_CARD}
                        onClick={showCards}
                    />
                ) : (
                    <ActionButton2
                        icon={{ iconName: show ? 'minus' : 'plus' }}
                        highlighted={show}
                        onClick={showCards}
                    />
                )}
            </S_Mid>
            {show && (
                <motion.div {...ANIMATION_APPEAR}>
                    <S_SidebarGrid
                        selectedIndex={-1}
                        columns={5}
                        items={addCard.cards.map((card) => {
                            return (
                                <S_Card
                                    key={card.title}
                                    onClick={() => {
                                        add(card);
                                    }}
                                >
                                    <S_Icon icon={[card.iconSet, card.iconName]} />
                                    <S_Text>{card.title}</S_Text>
                                </S_Card>
                            );
                        })}
                        onClick={(newIndex) => {
                            console.log(newIndex);
                        }}
                    />
                </motion.div>
            )}
        </S_AddCard>
    );
};

const S_AddCard = styled.div`
    display: flex;
    width: 100%;
    flex-direction: column;
    pointer-events: all;
`;

const S_Mid = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;

const S_Card = styled.div`
    display: flex;
    flex-direction: column;
    width: 55px;
    height: 55px;
    align-items: center;
    justify-content: center;
    padding: 9px;
    box-sizing: content-box;
`;

const S_Icon = styled(FontAwesomeIcon)`
    font-size: 20px;
    color: ${EColors.DARK};
    margin: 0 0 10px 0;
`;

const S_Text = styled.div`
    font-size: 12px;
    color: ${EColors.DARK};
    font-family: ${EFonts.Regular};
    text-align: center;
`;

const S_SidebarGrid = styled(SidebarGrid)`
    margin: 15px 0 0 0;
`;
